export default [
    {
        path: "/statistics/financial",
        component: () => import("@/views/Statistics/Financial/index"),
        props: true,
    },
    {
        path: "/statistics/sales/status/users",
        component: () => import("@/views/Statistics/Sales/Status"),
        props: true,
    },
    {
        path: "/statistics/revenue/group",
        component: () => import("@/views/Statistics/Revenue/Group"),
        props: true,
    },
    {
        path: "/statistics/sales/conversion/:userid",
        component: () => import("@/views/Statistics/Sales/ConversionDetail"),
        props: true,
    },
    {
        path: "/statistics/sales/conversion",
        component: () => import("@/views/Statistics/Sales/Conversion"),
        props: true,
    },
    {
        path: "/statistics/sales/customer_accept/:userid",
        component: () =>
            import("@/views/Statistics/Sales/CustomerAcceptDetail"),
        props: true,
    },
    {
        path: "/statistics/sales/customer_accept",
        component: () => import("@/views/Statistics/Sales/CustomerAccept"),
        props: true,
    },
    {
        path: "/statistics/product/sold",
        component: () => import("@/views/Statistics/product/index"),
        props: true,
    },
    {
        path: "/statistics/leads",
        component: () => import("@/views/Statistics/Leads"),
        props: true,
    },
    {
        path: "/phone-call",
        component: () => import("@/views/PhoneCall/index"),
        props: true,
    },
    {
        path: "/statistics/travelmiles",
        component: () => import("@/views/Statistics/TravelMile/index"),
        props: true,
    },
    {
        path: '/statistics/travelmiles/customers',
        component: () => import("@/views/Statistics/TravelMile/Customer"),
        props: true,
    },
];
